import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import { defineResources } from "jadro-pico-app/Resources/defineResources";

export const RacerProfileResources = defineResources({
  [LanguageEnum.CS]: {
    sectionTitle: "Beer Rally Profil",
    fieldTeam: "Tým",
    fieldLicence: "Licence",
    fieldBeer: "Pivo",
    fieldClass: "Třída",
    operationLabel: "Uložení profilu",
    saveSubmitted: "Změny profilu odeslány",
  },
  [LanguageEnum.EN]: {
    sectionTitle: "Beer Rally Profile",
    fieldTeam: "Team",
    fieldLicence: "Licence",
    fieldBeer: "Beer",
    fieldClass: "Class",
    operationLabel: "Profile save",
    saveSubmitted: "Profile changes submitted",
  },
});
